


























import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState, mapActions, mapGetters } from "vuex";
import * as a from "@/store/modules/NotificationsModule/actions";

// Vue Components
import UpdateNotificationsView from "./UpdateNotificationsView.vue";
import SecurityNotificationsView from "./SecurityNotificationsView.vue";
import OneTimeCodeNotificationsView from "./OneTimeCodeNotificationsView.vue";

// Model
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { LicenseData } from "@/model/data/License/LicenseData";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: { UpdateNotificationsView, SecurityNotificationsView },
    props: {
        loomisStyle: Boolean,
    },
    data() {
        return { NotificationTypesEnum };
    },
    computed: {
        ...mapState({
            notificationTypes: (state: RootState) => state.notifications.notificationTypes,
            totalNotReadNotifications: (state: RootState) => state.notifications.totalNotRead,
            notReadList: (state: RootState) => state.notifications.notReadList,
            licenseModules: (state: RootState) => state.license.licenseModules,
        }),
        ...mapGetters(["notificationEnabled", "authUserHasPrivilege"]),

        availableNotificationTypes() {
            let res = [];

            if (
                (this.licenseModules as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement) &&
                this.notReadList &&
                this.authUserHasPrivilege(ClientPrivileges.UpdatesManagement)
            ) {
                res.push({
                    type: NotificationTypesEnum.Update,
                    text: this.$t("notifications.updates"),
                    notReadCount:
                        this.notReadList.filter((c) => c.notificationType == NotificationTypesEnum[0]).length > 0
                            ? this.notReadList.filter((c) => c.notificationType == NotificationTypesEnum[0])[0].notRead
                            : -1,
                    component: UpdateNotificationsView,
                });
            }

            if (
                (this.licenseModules as LicenseData).isAvailable(LicenseModuleEnum.SecurityManagement) &&
                this.notReadList &&
                (this.authUserHasPrivilege(ClientPrivileges.SecurityManagement) ||
                    this.authUserHasPrivilege(ClientPrivileges.RollsConfigurationManagement) ||
                    this.authUserHasPrivilege(ClientPrivileges.CaosConfigurationManagement))
            ) {
                res.push({
                    type: NotificationTypesEnum.Security,
                    text: this.$t("notifications.security"),
                    notReadCount:
                        this.notReadList.filter((c) => c.notificationType == NotificationTypesEnum[1]).length > 0
                            ? this.notReadList.filter((c) => c.notificationType == NotificationTypesEnum[1])[0].notRead
                            : -1,
                    component: SecurityNotificationsView,
                });
            }

            if (
                (this.licenseModules as LicenseData).isAvailable(LicenseModuleEnum.OneTimeCode) &&
                this.notReadList &&
                (this.authUserHasPrivilege(ClientPrivileges.SmartLockActivation) || this.authUserHasPrivilege(ClientPrivileges.SmartLockManagement))
            ) {
                res.push({
                    type: NotificationTypesEnum.OneTimeCode,
                    text: this.$t("notifications.oneTimeCode"),
                    notReadCount:
                        this.notReadList.filter((c) => c.notificationType == NotificationTypesEnum[2]).length > 0
                            ? this.notReadList.filter((c) => c.notificationType == NotificationTypesEnum[2])[0].notRead
                            : -1,
                    component: OneTimeCodeNotificationsView,
                });
            }

            return res;
        },
    },
    watch: {
        totalNotReadNotifications(value) {
            if (!this.loomisStyle) {
                let link: HTMLAnchorElement = document.querySelector("link[rel~='icon']");
                if (value > 0) link.href = "assets/favicon_notification.png";
                else link.href = "assets/favicon.png";
            }
        },
    },
    methods: {
        ...mapActions([a.TOTAL_NOT_READ_NOTIFICATIONS]),
    },
    mounted() {
        if (this.notificationEnabled) this[a.TOTAL_NOT_READ_NOTIFICATIONS]();
    },
});
